import { render } from "./futuros_baremos.vue?vue&type=template&id=5e7c116a&scoped=true"
import script from "./futuros_baremos.vue?vue&type=script&lang=js"
export * from "./futuros_baremos.vue?vue&type=script&lang=js"

import "./futuros_baremos.vue?vue&type=style&index=0&id=5e7c116a&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e7c116a"]])

export default __exports__